<template>
    <div id="about-alliances">
        <!--=====================================-->
        <!--=      Case Study  Area Start       =-->
        <!--=====================================-->
        <section class="section mb--80">
            <div class="container">
                <div class="section-heading heading-light-left mb-0">
                    <span class="subtitle emerge-red bold">EMERGE.</span>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-8 col-lg-6">
                        <div class="mb--100">
                            <h2 class="font-weight-100">Nuestras <span class="bold">alianzas.</span></h2>
                            <p class="black body-font-1">
                                Coca-Cola FEMSA, RedGirasol y la Cooperación Alemana
                                para el Desarrollo Sustentable (GIZ) en México,
                                con el apoyo de nuestros aliados, buscamos facilitar
                                el acceso a financiamiento para energía limpia al sector MIPyME.
                            </p>
                            <!-- <div class="row">
                                <div class="col-sm-6 col-md-6 col-lg-5">
                                    <button @click.stop="goToTop()"
                                        class="axil-btn btn-borderd p-4 bg-emerge-red border-emerge-red mb-2 w-100">Socios
                                        implementadores</button>
                                </div>
                                <div class="col-sm-6 col-md-6 col-lg-5">
                                    <button @click.stop="goToTop()"
                                        class="axil-btn btn-borderd p-4 bg-emerge-red border-emerge-red w-100">Aliados</button>
                                </div>
                            </div> -->
                        </div>

                        <div class="section-heading heading-light-left mb-0">
                            <span class="subtitle emerge-red bold">¿Por qué EMERGE?</span>
                            <h2 class="font-weight-100">Invierte en negocios
                                                        que generan ahorros
                                                        con <span class="bold">energía limpia.</span>
                            </h2>
                        </div>
                        <p class="black body-font-1">
                            En México operan más de un millón de pequeños negocios minoristas
                            (conocidos nacionalmente como “changarros”) y aproximadamente 600,000
                            son clientes de Coca-Cola FEMSA. Estos "changarros", se encuentran
                            actualmente en un entorno complejo, con poco acceso a financiamiento,
                            lo que les genera retos operativos que dificultan su permanencia en operación.
                            <br><br>
                            Por otro lado, se estima que el costo por el consumo de energía eléctrica
                            dentro de cada establecimiento representa entre ~50-70% del costo total
                            de su operación. Este proyecto ayudará a contribuir en la mitigación
                            de este problema al proveer de energía solar generada en el lugar
                            y generar un ahorro en su factura mensual de electricidad.
                        </p>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-6 align-self-center" data-sal="slide-up" data-sal-duration="750">
                        <div class="align-end">
                            <img class="w-75"
                                src="https://cdn.redgirasol.com/nuevo_portal/emerge/extras/extra-01.png"
                                alt="emerge-rg">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "AboutAlliances",
    data: () => ({

    }),
}
</script>